import PropTypes from 'prop-types';
import ResizedImage from 'shared/components/resized-image/resized-image';

const ImageCover = ({ width, height, posterUrl }) => (
  <ResizedImage src={posterUrl}
                width={width}
                height={height}
                withFallbackColor={!posterUrl} />
);


ImageCover.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  posterUrl: PropTypes.string,
};

export default ImageCover;



// WEBPACK FOOTER //
// ./src/widget/containers/channel-cover/image-cover/image-cover.js